import { useMutation } from 'react-query';

import { http, camelCaseToUnderscore, underscoreToCamelCase } from '../base/http';
import type { Field, FieldValue } from '../types';

export const useCreateFieldMutation = (args: Record<string, unknown> = {}) => {
    return useMutation({
        mutationFn: (field: Field) =>
            http.post<Field>('/fields', camelCaseToUnderscore(field)).then((d) => underscoreToCamelCase(d)),
        ...args,
    });
};

export const useUpdateFieldMutation = (args: Record<string, unknown> = {}) => {
    interface UpdateFieldResponse {
        value: string;
    }

    return useMutation({
        mutationFn: (field: Field) =>
            http
                .put<UpdateFieldResponse>(`/fields/${field.id}`, camelCaseToUnderscore(field))
                .then((d) => underscoreToCamelCase(d)),
        ...args,
    });
};

export const useDeleteFieldMutation = (args: Record<string, unknown> = {}) => {
    return useMutation({
        mutationFn: (id: number) => http.delete(`/fields/${id}`),
        ...args,
    });
};

export const useCreateFieldValueMutation = (args: Record<string, unknown> = {}) => {
    return useMutation({
        mutationFn: (fieldValue: FieldValue) =>
            http
                .post<FieldValue>('/field_values', camelCaseToUnderscore(fieldValue) as Record<string, unknown>)
                .then((d) => underscoreToCamelCase(d)),
        ...args,
    });
};

export const useUpdateFieldValueMutation = (args: Record<string, unknown> = {}) => {
    return useMutation({
        mutationFn: (data: { id: number; value: string }) =>
            http
                .put<FieldValue>(`/field_values/${data.id}`, { value: data.value })
                .then((d) => underscoreToCamelCase(d)),
        ...args,
    });
};
